import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BaseService } from '../../services/base.service';
import {Document} from '../models/Document';
import { Observable } from 'rxjs';
import { IQueryResult } from '../../base/interfaces/IQueryResult';
import { IFileStoreItem } from '../interfaces/IFileStoreItem';
import { DocumentFilterDto } from '../../models/filters/document-filter.dto';
import { ExportType } from '../../models/export-type.model';
import { IOperationResult } from '../../base/interfaces/ioperation-result';
import { IExportResult } from '../../base/interfaces/IExportResult';
import { FileUploadService } from '../../directives/file-drop/file-upload.service';

@Injectable()
export class DocumentService extends BaseService<Document> {
  /**
   *
   */
  constructor(
    http: HttpClient,
    private fileStoreService:FileUploadService ,
    @Inject('BASE_URL') rootUrl: string
  ) {
    super(http, rootUrl, 'Document');
  }
  DeleteFile(file: IFileStoreItem):Observable<any> {
    return this.fileStoreService.Delete(file);
  }
  Query(index: string, query: string, skip?: number, take?: number, sortBy?: string, sortDesc: Boolean = false): Observable<IQueryResult<Document>> {
    let params = new HttpParams();
    if (index) {
      params = params.append('typeId', index);
    }
    if (query) {
      params = params.append('querystring', query);
    }
    if (skip) {
      params = params.append('$skip', skip.toString());
    }
    if (take) {
      params = params.append('$top', take.toString());
    }
    if (sortBy) {
      params = params.append('sort', sortBy);
    }
    params = params.append('sortDesc', sortDesc.toString());
    
    return this.http.get<IQueryResult<Document>>(`${this.rootUrl}/${this.endpoint}`, {params: params});
  }
  AdvancedQuery(index: string, query: DocumentFilterDto, skip?: number, take?: number, sortBy?: string, sortDesc: Boolean = false): Observable<IQueryResult<Document>> {
    let params = new HttpParams();
    if (skip) {
      params = params.append('$skip', skip.toString());
    }
    if (take) {
      params = params.append('$top', take.toString());
    }
    if (sortBy) {
      params = params.append('sort', sortBy);
    }
    params = params.append('sortDesc', sortDesc.toString());
    
    return this.http.post<IQueryResult<Document>>(`${this.rootUrl}/${this.endpoint}/query/${index}`, query, {params: params});
  }  
  GetDownloadLink(id: string) {
    return `${this.rootUrl}/${this.endpoint}/Download/${id}`;
  }
  getThumbnail(file: IFileStoreItem): string {
    let ret = 'fa-file';
    const d = Object.assign({}, file);
    if (!file || file.contentType === null) {
      return ret;
    } else if (file.contentType.startsWith('application/pdf')) {
      ret = 'fa-file-pdf-o';
    } else if (file.contentType.startsWith('text/')) {
      ret = 'fa-file-text';
    } else if (file.contentType.startsWith('application/x-zip')) {
      ret = 'fa-file-archive-o';
    } else if (file.contentType.startsWith('application/')) {
      ret = 'fa-file';
    } else if (file.contentType.startsWith('image/')) {
      ret = 'fa-file-image-o';
    } else {
      ret = 'fa-file-o';
    }
    return ret;
  }
  hasPreview(file: IFileStoreItem) {
    let ret = false;
    if (file && file.contentType !== null) {
      if (file.contentType.startsWith('image') || file.contentType.startsWith('video') || file.contentType === 'application/pdf') {
        ret = true;
      }
    }

    return ret;
  }
  getExportTypes(type:string) : Observable<ExportType[]> {
    return this.http.get<ExportType[]>(`${this.rootUrl}/${this.endpoint}/export/${type}`);
  }
  export(index: string, type:string, query: DocumentFilterDto, skip?: number, take?: number, sortBy?: string, sortDesc: Boolean = false) : Observable<any> {
    let params = new HttpParams();
    if (skip) {
      params = params.append('$skip', skip.toString());
    }
    if (take) {
      params = params.append('$top', take.toString());
    }
    if (sortBy) {
      params = params.append('sort', sortBy);
    }
    params = params.append('sortDesc', sortDesc.toString());    
    return this.http.post<IOperationResult<IExportResult>>(`${this.rootUrl}/${this.endpoint}/export/${index}/${type}`, query, {params: params});
  }
  formatStringOverflow(text: string, length: number = 15) {
    if (text === null) {
        return '';
    }
    if (text.length <= length) {
        return text;
    }
    text = text.substring(0, length);
    const last = text.lastIndexOf(' ');
    text = text.substring(0, last);
    return text + '...';
  }
  reindex(ids: string[]): Observable<any> {
    return this.http.put(`${this.rootUrl}/${this.endpoint}/reindex`,ids);
  }
}
